import i18n from "../../constants/i18n";
import { ON_CALL_HEADERS } from "../../constants/table-custom-headers/Alarms";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Table from "../../core/et3-table";
import getOnCallTeamStore from "../../stores/developer-store/on-call-team-store";

const AlarmTeam = withLiteObserverAndTheme(() => {
  const onDutyOnCallTeam = getOnCallTeamStore().onDutyOnCallTeamUpdated.get();

  return (
    <Et3Table
      columns={ON_CALL_HEADERS}
      title={i18n.get("ON_CALL_TEAM")}
      rows={onDutyOnCallTeam}
      shouldBeFlagged={false}
      titleKey={"ON_CALL_TEAM"}
    />
  );
});

export default AlarmTeam;
